// extracted by mini-css-extract-plugin
module.exports = {"closeBtn":"styles_closeBtn__2fO7C","closeBtnText":"styles_closeBtnText__14W83"};